// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__LGt7T","root_background":"Footer_root_background__qs3c-"};